export default {
    error: "auth.error",
    toggleButton: "auth.buttons.toggle"
}